/**
 * Router singleton instance.
 *
 * Created with only the /login route pre-registered so that stores
 * (e.g. auth.store) can navigate to /login immediately after import,
 * even before main.ts populates the full route table.
 *
 * All other routes are added dynamically by main.ts via router.addRoute()
 * to avoid circular dependencies (store → router → routes → components → store).
 */
import { createRouter, createWebHistory } from 'vue-router';
import i18next from 'i18next';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { title: () => i18next.t('router.login'), requiresAuth: false, layout: 'blank' },
    },
  ],
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }
    return { top: 0 };
  },
});
